// Opens accordion items on init for any .yn-accordions[data-open-on-init].
// Value is a comma-separated list of 0-based indices, e.g. data-open-on-init="0"
// or data-open-on-init="0,2". Runs after the vendor YnfiniteAccordions.setup()
// has attached the Accordion instance as element._accordion.
export function accordions() {
	const groups = document.querySelectorAll('.yn-accordions[data-open-on-init]')
	if (!groups.length) return

	groups.forEach((group) => {
		const raw = group.getAttribute('data-open-on-init') || ''
		const indices = raw
			.split(',')
			.map((v) => parseInt(v.trim(), 10))
			.filter((n) => !Number.isNaN(n))

		if (!indices.length) return

		const open = () => {
			const instance = group._accordion
			if (instance && typeof instance.open === 'function') {
				indices.forEach((i) => instance.open(i))
				return true
			}
			return false
		}

		// vendor may not have attached the instance yet — retry a few frames
		if (open()) return

		let tries = 0
		const tick = () => {
			if (open() || ++tries > 20) return
			requestAnimationFrame(tick)
		}
		requestAnimationFrame(tick)
	})
}
